/* Brand-neutral blog carousel — Swiper init with center-scale plugin.
   Ported from symbolika-blog.js initFeaturedCarousel (lines 378-463). */

(function() {

  function interpolate(value, inputRange, outputRange) {
    var len = inputRange.length;
    if (value <= inputRange[0]) {
      var s = (outputRange[1] - outputRange[0]) / (inputRange[1] - inputRange[0]);
      return outputRange[0] + s * (value - inputRange[0]);
    }
    if (value >= inputRange[len - 1]) {
      var s = (outputRange[len - 1] - outputRange[len - 2]) / (inputRange[len - 1] - inputRange[len - 2]);
      return outputRange[len - 1] + s * (value - inputRange[len - 1]);
    }
    for (var i = 0; i < len - 1; i++) {
      if (value >= inputRange[i] && value <= inputRange[i + 1]) {
        var t = (value - inputRange[i]) / (inputRange[i + 1] - inputRange[i]);
        return outputRange[i] + t * (outputRange[i + 1] - outputRange[i]);
      }
    }
    return outputRange[len - 1];
  }

  function initCarousel(el) {
    if (el.dataset.blogCarouselInit) return;

    /* Bail WITHOUT setting the dataset flag when Swiper isn't loaded yet —
       a later retry (window.load / shopify:section:load / click handler
       lazy-init) will try again. The bug: setting the flag before this
       check left in-body carousels permanently un-initialized when their
       <script src="blog-carousel.js"> tag (emitted inside the article
       body via the shell snippet) executed before swiper-bundle.min.js
       in the layout head finished loading. */
    if (typeof Swiper === 'undefined') return;

    el.dataset.blogCarouselInit = '1';

    /* Detect blog-index instances vs article-page instances. The index
       carousel section has class `shopify-section-group-blog-index-stack-
       group` (added by Shopify because it's rendered via a section group).
       Article-page instances don't have that class. This is structural
       (DOM), not viewport-dependent, so it's safe to compute once at init. */
    var hostSection = el.closest('.blog-carousel-section');
    var isIndex = hostSection && hostSection.classList.contains('shopify-section-group-blog-index-stack-group');
    var desktopGap = isIndex ? 60 : 44;

    /* Swiper-v8 loop polyfill. With slidesPerView:'auto' + centeredSlides:true
       + loop:true, Swiper 11 wraps slides to only ONE side at low N (upstream
       bug #7239, open since 2023). The fix lives in Liquid now — see
       sections/blog-carousel.liquid + snippets/blog-product-carousel.liquid:
       the markup arrives with cloned slides already appended when unique
       count < 11. Clones carry data-clone="true" aria-hidden="true"
       tabindex="-1" so they're inert to assistive tech, keyboard nav, and
       analytics. The click handler below normalizes clone-clicks to the
       corresponding real slide. */

    /* Use Swiper's native `breakpoints` config — it RESPONSIVELY switches
       params when the viewport crosses the breakpoint width. spaceBetween
       outside `breakpoints` is the base/mobile value; overrides inside
       `breakpoints: { 768: ... }` apply only at ≥768px viewports.
       Mobile (<768): always 20. Desktop (≥768): 60 on index, 44 on article. */
    new Swiper(el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 20,
      breakpoints: {
        768: {
          spaceBetween: desktopGap,
        },
      },
      speed: 400,
      grabCursor: true,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      on: {
        progress: function() {
          var sw = this;
          var sizes = sw.slidesSizesGrid;
          for (var i = 0; i < sw.slides.length; i++) {
            var slide = sw.slides[i];
            var progress = slide.progress;
            var scale = Math.max(interpolate(Math.abs(progress), [0, 1], [1, 0.85]), 0.8);
            var slideWidth = sizes[i] || slide.offsetWidth;
            var sizeDiff = slideWidth - slideWidth * scale;
            var translateX = interpolate(
              progress,
              [-2, -1, 0, 1, 2],
              [-1.8 * sizeDiff, -0.6 * sizeDiff, 0, 0.6 * sizeDiff, 1.8 * sizeDiff]
            );
            slide.style.transform = 'scale(' + scale + ') translateX(' + translateX + 'px)';
          }
        },
        setTransition: function(sw, duration) {
          for (var i = 0; i < sw.slides.length; i++) {
            sw.slides[i].style.transitionDuration = duration + 'ms';
          }
        }
      }
    });
  }

  function initAll() {
    var tracks = document.querySelectorAll('.blog-carousel__track');
    for (var i = 0; i < tracks.length; i++) {
      initCarousel(tracks[i]);
    }
  }

  document.addEventListener('click', function(e) {
    var card = e.target.closest('.blog-carousel__card');
    if (!card) return;
    var slide = card.closest('.swiper-slide');
    if (!slide) return;
    var track = card.closest('.blog-carousel__track');
    if (!track) return;

    /* Lazy-init if the track was never initialized (e.g., Swiper bundle
       loaded after the first init attempt fired). */
    if (!track.swiper) initCarousel(track);
    if (!track.swiper) return;

    if (slide.classList.contains('swiper-slide-active')) return;
    e.preventDefault();
    var idx = parseInt(slide.dataset.swiperSlideIndex, 10);
    if (!isNaN(idx)) track.swiper.slideToLoop(idx);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAll, 100);
    });
  } else {
    setTimeout(initAll, 100);
  }

  /* window.load fires AFTER all assets settle — by which point Swiper bundle
     is guaranteed available. Catches the race where the in-body
     <script src="blog-carousel.js"> tag executes before swiper-bundle.min.js
     in the layout head finished loading. initCarousel is idempotent
     thanks to the dataset.blogCarouselInit guard. */
  window.addEventListener('load', function() {
    setTimeout(initAll, 50);
  });

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.blog-carousel__track')) {
      setTimeout(initAll, 200);
    }
  });
})();
